import React, { useState } from "react"
import PropTypes from "prop-types"
import * as styles from "./Styles/ContentWrapper.module.scss"
import CrowdLampSwitch from "./CrowdLampSwitch"
import ShelterLampSwitch from "./ShelterLampSwitch"
import PlaceInformation from "./Place/Information"
import Widget from "./Widget"
import Menu from "./Menu"
import Icon from "../Utils/Icon"
import Term from "./Term"
import Help from "./Help"
import PlaceSwitchModal from "./PlaceSwitchModal"

const PlaceSwitcher = (props) => {
  const [show, setShow] = useState(false)
  return (
    <div className={styles.place}>
      <a
        href="#"
        onClick={() => {
          setShow(true)
        }}
        className={styles.placeName}
      >
        <span>{props.place.name}</span>
        <Icon className={styles.external} type="feather" name="chevron-down" />
      </a>
      <a href={props.place.path} target="_blank">
        <span>ページを見る</span>
        <Icon className={styles.external} type="feather" name="external-link" />
      </a>
      <PlaceSwitchModal
        show={show}
        onClose={() => {
          setShow(false)
        }}
        places={props.places}
        place={props.place}
      />
    </div>
  )
}

const ContentWrapper = (props) => {
  return (
    <div className={styles.contentWrapper}>
      <div className={styles.content}>
        <PlaceSwitcher places={props.editablePlaces} place={props.place} />
        <h1>{Menu[props.contentType].title}</h1>
        <hr />
        <div>
          {props.contentType == "lamp" && (
            <CrowdLampSwitch place={props.place} params={props.contentParams} />
          )}
          {props.contentType == "shelterLamp" && (
            <ShelterLampSwitch
              place={props.place}
              params={props.contentParams}
            />
          )}
          {props.contentType == "widget" && (
            <Widget place={props.place} params={props.contentParams} />
          )}
          {props.contentType == "place" && (
            <PlaceInformation
              place={props.place}
              params={props.contentParams}
            />
          )}
          {props.contentType == "terms" && <Term />}
          {props.contentType == "help" && <Help />}
        </div>
      </div>
    </div>
  )
}
ContentWrapper.propTypes = {
  contentType: PropTypes.string,
  contentParams: PropTypes.any,
  place: PropTypes.any,
}
export default ContentWrapper
